import { styled } from '@mui/material';

import { ReactNode } from 'react';

import { I18nResources, useI18n } from '@app-velocity/i18n';
import { BackArrowIcon } from '@app-velocity/icons';

import { Box } from '../../../Box';
import { useModalContext } from '../../context/useModalContext';

import { HeaderWrapper } from './HeaderWrapper';

export type BackHeaderProps = {
  label: I18nResources | ReactNode;
  children?: ReactNode;
};

const StyledBackArrowContainer = styled(Box)({
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  gap: 'calc(var(--basic-grid) * 2)',
  color: 'var(--color-general-grey-500)',
  fontWeight: 'var(--font-weight-regular)',
  fontSize: 'var(--font-size-regular)',
  lineHeight: 'var(--line-height-medium)',
  justifyContent: 'space-around',
  minWidth: 0,
});

const IconContainer = styled('div')({
  flex: '0 0 auto',
});

const LabelContainer = styled('div')({
  flex: 1,
  overflow: 'hidden',
});

export const BackHeader = ({ label, children }: BackHeaderProps) => {
  const { closeModal } = useModalContext();

  const { t } = useI18n();

  return (
    <HeaderWrapper>
      <StyledBackArrowContainer
        data-testid="modal-close-icon"
        onClick={() => closeModal()}
      >
        <IconContainer>
          <BackArrowIcon />
        </IconContainer>
        <LabelContainer>
          {typeof label === 'string' ? t(label as I18nResources) : label}
        </LabelContainer>
      </StyledBackArrowContainer>
      {children}
    </HeaderWrapper>
  );
};
